import {
	checkValidationErrors,
	TSaveQrResponse,
} from 'features/generator/utils/qrSavingUtils'

import { ROUTES } from '@/constants'
import { isAuthenticatedAtom } from '@/global-state'
import { getStore } from '@/store'
import { getSearchParams } from '@/utils'

import { qrNameAtom } from '../../contentFormSections'
import { qrPreviewDesignAtom } from '../../GeneratorLayout/qrPreviewDesignState'
import { qrUriAtom } from '../../generatorState'
import {
	GENERATOR_SEARCH_PARAM,
	QR_TYPE,
	TQrContent,
} from '../../generatorTypes'
import { qrCodesApi } from '../../services/shared'
import { getQrDataToEncode } from '../../utils/buildQrLandingUrl'
import { getGeneratorSearchParam } from '../../utils/generatorSearchParam'
import { QR_TYPE_TO_CONTENT_ATOM } from '../../utils/qrTypeToContentAtom'
import { withScannableLogo } from '../../utils/withScannableLogo'

let putCurrQrQueue: Promise<unknown> = Promise.resolve()

const saveCurrQr = async (qrType: QR_TYPE) => {
	const qrId = getGeneratorSearchParam(GENERATOR_SEARCH_PARAM.Id)
	if (!qrId) {
		throw new Error('Saving QR failed: Missing QR ID')
	}
	const name = getStore().get(qrNameAtom) || ''
	const contentAtom = QR_TYPE_TO_CONTENT_ATOM[qrType]
	const content = getStore().get(contentAtom) as TQrContent
	const qrUri = getStore().get(qrUriAtom)
	const qrPreviewDesign = await withScannableLogo(
		getStore().get(qrPreviewDesignAtom),
		() => (qrUri ? getQrDataToEncode({ qrUri, qrContent: content }) : null),
	)
	const putQr = getStore().get(isAuthenticatedAtom)
		? qrCodesApi.putQr
		: qrCodesApi.putQuestQr
	const res = await putQr(qrId, {
		name,
		content,
		qrDesign: qrPreviewDesign,
	})
	checkValidationErrors(res as unknown as TSaveQrResponse)
}

export const putCurrQr = (qrType: QR_TYPE) => {
	const result = putCurrQrQueue.then(() => saveCurrQr(qrType))
	putCurrQrQueue = result.catch(() => undefined)
	return result
}

export const buildDashboardWithNewQrPopupUrl = (
	newQrId: string,
	mode: 'create' | 'edit',
) => {
	const searchParams = new URLSearchParams()
	if (mode === 'create') {
		searchParams.set('qr_creation', 'true')
	}
	searchParams.set('open-modal', 'qr-code-download')
	searchParams.set('id', newQrId)

	return `${ROUTES.cabinet.qrCodes}?${searchParams.toString()}`
}

export const publishNewQr = async () => {
	const searchParams = getSearchParams()
	const qrId = searchParams.get('id')
	if (!qrId) {
		throw new Error('Missing QR ID')
	}
	await qrCodesApi.publishQr(qrId)
}
